<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/jala-harvest";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit JALA Harvests",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_harvests.singular')) }},
    resourceRoute: {default: 'jala_harvests'},
    modelVariable: {default: 'jala_harvest'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_harvests.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_harvests.plural')),
          href: "/jala_harvests",
        },
        {
          text: this.model && this.model.id ? this.model['id'] : this.$route.params.key,
          href: `/jala_harvests/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/jala_harvests/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/jala/harvests/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/jala/harvests/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/jala/harvests/${this.$route.params.key}`)
    }
  }
}
</script>
